/**
 * @generated SignedSource<<fd4d1f57add57f61169b6fa21e21afba>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type OpsDevicesPagePairingQuery$variables = {
  id: string;
};
export type OpsDevicesPagePairingQuery$data = {
  readonly devicePairing: {
    readonly claimedAt: any | null | undefined;
    readonly device: {
      readonly name: string;
    } | null | undefined;
    readonly id: string;
  } | null | undefined;
};
export type OpsDevicesPagePairingQuery = {
  response: OpsDevicesPagePairingQuery$data;
  variables: OpsDevicesPagePairingQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "claimedAt",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "OpsDevicesPagePairingQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DevicePairing",
        "kind": "LinkedField",
        "name": "devicePairing",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Device",
            "kind": "LinkedField",
            "name": "device",
            "plural": false,
            "selections": [
              (v4/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "OpsDevicesPagePairingQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DevicePairing",
        "kind": "LinkedField",
        "name": "devicePairing",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Device",
            "kind": "LinkedField",
            "name": "device",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "f17d7545ce7afa71d7289ef9a385819b",
    "id": null,
    "metadata": {},
    "name": "OpsDevicesPagePairingQuery",
    "operationKind": "query",
    "text": "query OpsDevicesPagePairingQuery(\n  $id: ID!\n) {\n  devicePairing(id: $id) {\n    id\n    claimedAt\n    device {\n      name\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "8a19144bcae3a786a1a41d119c17a676";

export default node;
